import { EventEmitter } from 'eventemitter3'

import { Ready } from './Ready'

export enum EWSEvent {
  open = 'ws:open',
  reconnect = 'ws:reconnect',
  error = 'ws:error',
  close = 'ws:close',
  terminated = 'ws:terminated',
}

export interface IWSClient {
  isConnected: boolean
  isAuthorized: Ready
  isConnectionOpen: Ready
  ws: WebSocket | null
  connect(): Promise<void>
  call<T = any>(service: string, action: string, payload: any, returnError?: boolean): Promise<T>
  on(event: any, handler: (payload: any) => void): () => EventEmitter
  disconnect(): Promise<void>
}
